export class CompaniesResponseModel {
    constructor(obj) {
        this.Companies = obj.map((item) => new CompanyModel(item));
    }
}

export class CompanyModel {
    constructor(obj) {
        this.Id = obj.id;
        this.Name = obj.name;
        this.NameKana = obj.name_kana;
        this.DisplayName = obj.display_name;
        this.Role = obj.role;
    }
}

export class CompanyLocalModel {
    constructor(obj) {
        this.Id = obj.Id;
        this.Name = obj.Name;
        this.NameKana = obj.NameKana;
        this.DisplayName = obj.DisplayName;
        this.Role = obj.Role;
    }
}
